<template>
  <b-button
    class="main-bluebutton"
    :style="isLaptop ? `width: ${lapwidth}px` : `width:${mobwidth}px `"
    :class="{
      'width-100': type == 'full',
      'mobile-btn': type == 'mobile',
      'login-btn': type == 'login',
      'header-height': type == 'header',
      'width-50': type == 'half',
    }"
    @click.stop="$emit('clicked')"
    >{{ text }}</b-button
  >
</template>
<script>
export default {
  name: "BlueButton",
  props: {
    text: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    lapwidth: {
      type: Number,
      default: 250,
    },
    mobwidth: {
      type: Number,
      default: 160,
    },
  },
  data() {
    return {
      isLaptop: true,
    };
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize

    // Force hover state reset (Safari fix)
    window.addEventListener("pageshow", this.resetButtonHoverState);
    document.addEventListener("visibilitychange", this.handleTabSwitch);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
    window.removeEventListener("pageshow", this.resetButtonHoverState);
  document.removeEventListener("visibilitychange", this.handleTabSwitch);
  },
  methods: {
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
    resetButtonHoverState() {
      const btn = this.$el;
      if (btn && btn.nodeType === 1 && !btn.matches(':hover')) {
        btn.classList.add("reset-hover");
        void btn.offsetWidth; // trigger reflow
        btn.classList.remove("reset-hover");
      }
    },
handleTabSwitch() {
  if (document.visibilityState === "visible") {
    this.resetButtonHoverState(); // only resets if not hovered
  }
}
  },
};
</script>
<style>
.main-bluebutton {
  position: relative;
  overflow: hidden;
  border-radius: 50px;
  color: #fbfbfb;
  font-weight: 800;
  background-color: #52a6ff;
  font-family: "Inter", serif;
  font-size: 16px;
  border: none;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 1;
}

.header-height {
  height: 40px;
}

.main-bluebutton:not(:hover)::before {
  animation: reverseFillAnimation 0.3s ease forwards;
}
.main-bluebutton:focus {
  border-radius: 50px;
  color: #fbfbfb;
  background-color: #52a6ff;
  border: none;
  box-shadow: unset;
}
.main-bluebutton.reset-hover::before {
  animation: none !important;
  transform: none !important;
  background: transparent !important;
}
@media (min-width: 1029px) {
  .main-bluebutton:hover {
    border-radius: 50px;
    color: #fbfbfb;
    background-color: #52a6ff;
    border: none;
    box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
      2px 3px 7px 0px rgba(32, 99, 155, 0.2),
      7px 10px 12px 0px rgba(32, 99, 155, 0.17),
      44px 63px 22px 0px rgba(32, 99, 155, 0);
  }
  .main-bluebutton::before {
    content: "";
    position: absolute;
    inset: 0; /* Cover the entire button */
    background-color: #1e4f8b; /* Dark blue for the animation effect */
    transform: translateY(100%); /* Start outside at the bottom */
    border-radius: 0 0 100px 100px; /* Rounded corners at the bottom */
    z-index: -1; /* Place it behind the button text */
    transition: none; /* No transition by default */
  }

  .main-bluebutton:hover::before {
    animation: fillAnimation 0.3s ease forwards; /* Trigger the animation */
  }
}

@media (max-width: 1028px) {
  .mobile-btn {
    width: 160px;
    padding-inline: 0 !important;
    font-size: 15px !important;
  }
  .login-btn {
    width: 200px;
    padding-inline: 0 !important;
    font-size: 15px !important;
  }
  .width-50 {
    width: 50% !important;
  }
}

@keyframes fillAnimation {
  0% {
    transform: translateY(100%); /* Start below the button */
    border-radius: 0 0 50px 50px; /* Rounded corners at the bottom */
    background-color: #7da4d4; /* Dark blue for the animation effect */
  }
  20% {
    transform: translateY(70%); /* Move to the top */
    border-radius: 40px 40px 0 0; /* Rounded corners at the top */
    background-color: #7da4d4; /* Dark blue for the animation effect */
  }
  80% {
    transform: translateY(0); /* Move to the top */
    border-radius: 40px 40px 0 0; /* Rounded corners at the top */
  }
  90% {
    transform: translateY(0); /* Stay at the top */
    border-radius: 20px 20px 0 0; /* Gradually reduce to 20px */
  }
  95% {
    transform: translateY(0); /* Stay at the top */
    border-radius: 10px 10px 0 0; /* Gradually reduce to 10px */
  }
  100% {
    transform: translateY(0); /* Stay at the top */
    border-radius: 0 0 0 0; /* Remove rounding */
    background-color: #1e4f8b;
  }
}

@keyframes reverseFillAnimation {
  0% {
    transform: translateY(0);
    border-radius: 0 0 0 0;
    background-color: #1e4f8b;
  }
  5% {
    transform: translateY(0);
    border-radius: 10px 10px 0 0;
  }
  10% {
    transform: translateY(0);
    border-radius: 20px 20px 0 0;
  }
  80% {
    transform: translateY(0);
    border-radius: 40px 40px 0 0;
  }
  100% {
    transform: translateY(100%);
    border-radius: 0 0 50px 50px;
    background-color: #507fb8;
  }
}
.main-bluebutton:disabled {
  border-radius: 8px;
  color: #fbfbfb;
  background-color: #52a6ff;

  border: none;
  opacity: 0.5;
}
.main-bluebutton.btn-secondary:focus,
.btn-secondary.focus {
  background-color: #52a6ff !important;
  box-shadow: unset;
}

.main-bluebutton.btn-secondary:hover {
  color: #fff; /* Text color on hover */
  border-color: #52a6ff; /* Border color on hover */
  background-color: #52a6ff;
}

.main-bluebutton.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: #52a6ff;
  box-shadow: unset;
}
.main-bluebutton:disabled {
  opacity: 0.5;
}

.main-bluebutton span {
  position: relative; /* Keep the text above the pseudo-element */
  z-index: 1;
}
.width-100 {
  width: 100% !important;
  border-color: #52a6ff !important;
}

@media screen and (max-width: 1028px) {
  .main-bluebutton {
    height: 44px !important;
    font-size: 13px;
  }
}
</style>
